export default "__VITE_ASSET__BG4i4JmI__";